import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-renewals-matrix-contract-details',
  templateUrl: './renewals-matrix-contract-details.component.html',
  styleUrls: ['./renewals-matrix-contract-details.component.scss'],
})
export class RenewalsMatrixContractDetailsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
